var render = function render(){var _vm=this,_c=_vm._self._c;return _c('billing-report-panel',{attrs:{"report-key":"glosses-reason","route":"/reports/billing-glosses-reason","file-name":"glosas-por-motivo.xlsx","columns":_vm.columns,"show-professional":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }